var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 0.166992C10.3308 0.166992 10.9167 0.75293 10.9167 1.41699V2.12012C13.7292 2.58887 15.9167 5.0498 15.9167 7.97949V9.30762C15.9167 11.0654 16.5027 12.7842 17.5964 14.1904L18.1824 14.8936C18.4167 15.2061 18.4558 15.5967 18.2996 15.9092C18.1433 16.2217 17.8308 16.417 17.4792 16.417H1.85425C1.46362 16.417 1.15112 16.2217 0.994873 15.9092C0.838623 15.5967 0.877686 15.2061 1.11206 14.8936L1.698 14.1904C2.79175 12.7842 3.41675 11.0654 3.41675 9.30762V7.97949C3.41675 5.0498 5.56519 2.58887 8.41675 2.12012V1.41699C8.41675 0.75293 8.96362 0.166992 9.66675 0.166992ZM9.66675 3.91699H9.35425C7.08862 3.91699 5.29175 5.75293 5.29175 7.97949V9.30762C5.29175 11.1826 4.74487 12.9795 3.72925 14.542H15.5652C14.5496 12.9795 14.0417 11.1826 14.0417 9.30762V7.97949C14.0417 5.75293 12.2058 3.91699 9.97925 3.91699H9.66675ZM12.1667 17.667C12.1667 18.3311 11.8933 18.9951 11.4246 19.4639C10.9558 19.9326 10.3308 20.167 9.66675 20.167C9.00269 20.167 8.33862 19.9326 7.86987 19.4639C7.40112 18.9951 7.16675 18.3311 7.16675 17.667H9.66675H12.1667Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellLight);
export default __webpack_public_path__ + "static/media/bell_light.dcc3e2c1feeaacc20cdd7b86c3e8d1ac.svg";
export { ForwardRef as ReactComponent };